import { render, staticRenderFns } from "./CredentialFooter.vue?vue&type=template&id=044b3e41&"
import script from "./CredentialFooter.vue?vue&type=script&lang=ts&"
export * from "./CredentialFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialFooter.vue?vue&type=style&index=0&id=044b3e41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports